import script from "./vipView.vue?vue&type=script&setup=true&lang=ts"
export * from "./vipView.vue?vue&type=script&setup=true&lang=ts"

import "./vipView.vue?vue&type=style&index=0&id=1d2f6001&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2f6001"]])

export default __exports__